export default __webpack_public_path__ + "static/software-74467db27cac0f62fb8b0943df89fcaa.jpg";